import { createContext } from 'react';
import {IncludeAll} from "./constants";
import moment from "moment";

export const WizardContext = createContext(null);
export const WizardDefaultContext = {
  formData: {
    audienceType: 'custom',
    customer_list_id: null,
    targeting: {
      salary_range: [IncludeAll],
      have_children: IncludeAll,
      have_house: IncludeAll,
      have_pet: IncludeAll,
      employment_status: [IncludeAll],
      ageRange: [18, 70],
      gender: IncludeAll,
      relationship: [IncludeAll],
    },
    location: {
      states: [],
      counties: [],
      cities: [],
      zipCode: null,
      distance: 0,
    },
    campaignType: 'poll',
    responseType: 'yes-no',
    questionText: '',
    totalResponses: 0,
    launchDate: moment(new Date()),
    launchDateChoose: 'now',
    endDate: moment(new Date()).add(14, 'days'),
    couponExpireDate: moment(new Date()).add(30, 'days'),
    campaignEndWhen: 'allResponses',
    responseOptions: [{name: 'Yes'}, {name: 'No'}],
    campaignImage: null,
    paymentCard: {
      cvc: '',
      expiry: '',
      number: '',
      error: 'Enter card number'
    },
    discountCode: '',
  },
  fieldChange: () => () => {},
};

export const getFieldChangeSetter = (state, setStateAction, callback) => {
  return (name, targeting = false) => ({target: { value }}) => {
    let finalValue = value;
    switch (name) {
      case 'employment':
      case 'relationship':
      case 'salary_range': {
        if (state.targeting[name][0] === IncludeAll) {
          if (value[value.length - 1] !== IncludeAll) {
            finalValue = [value[value.length - 1]];
          }
        } else {
          if (value[value.length - 1] === IncludeAll) {
            finalValue = [IncludeAll];
          }
        }
      } break;
      case 'questionText':
        if (value.length > 500) {
          return;
        }
        break;
      case 'responseType':
        if (value === 'yes-no') {
          state.responseOptions = [{
            name: 'Yes',
          }, {
            name: 'No',
          }]
        } else if (value === 'true-false') {
          state.responseOptions = [{
            name: 'True',
          }, {
            name: 'False',
          }]
        }
        break;
      case 'campaignType':
        if (value === 'coupon') {
          state.responseOptions = [{
            name: "Accept",
          }, {
            name: "The deal isn't good enough...",
          }, {
            name: "The business is too far away...",
          }, {
            name: "The coupon will expire before I can use it...",
          }, {
            name: "I'm just not interested in this product or business...",
          }];
        } else if (state.campaignType === 'coupon') { // if we previously had coupon
          state.responseOptions = [{name: 'Yes'}, {name: 'No'}];
        }
        break;
    }

    let finalData;

    if (targeting) {
      finalData = {...state, targeting: {...state.targeting, [name]: finalValue}};
      setStateAction(finalData);
    } else {
      finalData = {...state, [name]: finalValue};
      setStateAction(finalData);
    }

    callback(name, targeting, value, finalData);
  };
};
